import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Heading, Text } from '@pancakeswap/uikit'
import { Mspaint } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'
import { AutoRow } from 'components/Layout/Row'
import nftGif from './nft.gif'

const NFTCreatorModal = ({ close, modalStyle, frameStyle }) => {
  const { t } = useTranslation()

  return (
    <Modal
      defaultPosition={{ x: 10, y: 10 }}
      icon={<Mspaint variant="16x16_4" />}
      title="NFT Creator - Coming Soon!"
      closeModal={close}
      buttons={[{ value: 'Ok', onClick: close }]}
      style={modalStyle}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`NFT Creator - Coming Soon!`)}
        </Heading>

        <Text fontSize="18px" mt="16px" mb="16px">
          {t(
            `NFTs are a fundamental part of the Windoge95 community ecosystem, and a great way for crypto enthusiasts and art enthusiasts alike to come together and create special, valuable work. Currently, NFTs are difficult to produce, requiring specialized software and expertise. But NFTs should be fun and easy for anyone to create - as easy as drawing a picture in MS Paint. Enter the Windoge95 NFT creator.`,
          )}
        </Text>
        <AutoRow gap="16px">
          <img
            style={{
              minWidth: '250px',
              maxWidth: '550px',
              height: '40%',
              minHeight: '250px',
              maxHeight: '550px',
              margin: '16px 0px',
            }}
            src="https://uploads-ssl.webflow.com/618355b75eeec9b5cc079e5c/6193227dc55119ffd6b7cf16_nft.png"
            alt="nft gif 2"
          />

          <img
            style={{
              minWidth: '250px',
              maxWidth: '550px',
              height: '40%',
              minHeight: '250px',
              maxHeight: '550px',
              margin: '16px 0px',
              borderRadius: '8px',
            }}
            src={nftGif}
            alt="nft gif"
          />
        </AutoRow>

        <Text fontSize="18px" mb="32px" mt="24px">
          {t(
            `One of the core strengths of this token is our community. We want to give you the tools to get creative and contribute to the culture of the coin! We can't wait to see the amazing art the community will create with this tool.`,
          )}
        </Text>
        <Text fontSize="18px">
          {t(
            `Beyond the creator, we are introducing an exchange + marketplace where you can browse NFTs that other holders have listed for sale. From the creator to the marketplace, our focus is on delivering value and utility to strengthen the future of the token.`,
          )}
        </Text>
      </Frame>
    </Modal>
  )
}

export default NFTCreatorModal
